import { Component } from '@angular/core';

@Component({
  selector: 'app-loading',
  templateUrl: './loading-indicator.component.html',
  styleUrls: ['./loading-indicator.component.scss'], // Corrected: `styleUrl` -> `styleUrls`
})
export class LoadingIndicatorComponent {}
